module.exports = __webpack_public_path__ + "img/only-rightwindow.b1ae04ba.svg";